import styled from '@emotion/styled';
import { Page } from '@hotjar/webapp/components/Page';
import { Table, tokens } from '@hotjar/hotsauce';

export const StyledPage = styled(Page)`
  padding-bottom: ${tokens.spacer.x4};
`;

export const FlexContainerCenter = styled.div`
  ${tokens.flexContainer()};

  align-items: center;
`;

export const TableHeadCellVerticalCenter = styled(Table.HeadCell)`
  vertical-align: middle;
`;

export const TableCellVerticalCenter = styled(Table.Cell)`
  vertical-align: middle;
`;

export const TableCellRightAligned = styled(Table.Cell)`
  text-align: right;
  vertical-align: middle;
`;
